import i18n, { i18n_t } from '@/locales/i18n';
import { SMH } from '@/renderer/scripts/libs/smh-sdk-class';
import { formatSize } from '@/renderer/scripts/utils/tools';
type Handler = {
  methods: {
    hasDownCountLimit: (item: SMH.GetShareLinkData) => boolean; // 是否达到
    hasPreviewCountLimit: (item: SMH.GetShareLinkData) => boolean;
    getAccessTraffic: (link: SMH.GetShareLinkData) => string; // 获取流量
    getDownCount: (link: SMH.GetShareLinkData, showTotal: boolean) => string; // 获取下载次数
    getPerCount: (link: SMH.GetShareLinkData, showTotal: boolean) => string; // 获取预览次数
  };
};

export default function linkDownAndPreviewHandler(): Handler {
  function formatSizeString(itemSize?: string) {
    const { size, unit } = formatSize(itemSize as string);
    return `${size} ${unit}`;
  }
  const methods = {
    hasDownCountLimit(item: SMH.GetShareLinkData) {
      // 下载是否达到上限
      if (!item.downloadCount) {
        // 不限制
        return false;
      }
      return item.downloadCountUsed === item.downloadCount;
    },
    hasPreviewCountLimit(item: any) {
      // 预览是否达到上限
      if (!item.previewCount) {
        // 不限制
        return false;
      }
      return item.previewCountUsed === item.previewCount;
    },
    getAccessTraffic(link: SMH.GetShareLinkData) {
      if (!link.shareTraffic) {
        return '0 B';
      }
      return formatSizeString(link.shareTraffic.toString());
    },
    getDownCount(link: SMH.GetShareLinkData, showTotal = true) {
      if (link.canDownload === false) {
        return i18n_t('禁止');
      }
      let used = link.downloadCountUsed;
      if (!used) {
        used = 0;
      }
      if (showTotal && link.downloadCount) {
        return `${used}/${link.downloadCount}`;
      }
      return `${used}`;
    },
    getPerCount(link: SMH.GetShareLinkData, showTotal = true) {
      if (link.canPreview === false) {
        return i18n_t('禁止');
      }
      let used = link.previewCountUsed;
      if (!used) {
        used = 0;
      }
      if (showTotal && link.previewCount) {
        return `${used}/${link.previewCount}`;
      }
      return `${used}`;
    },
  };
  return {
    methods,
  };
}
